import React from "react";
import styled from "styled-components";

// StyledDiv 컴포넌트에서 modal 및 modal-content 스타일 수정
const StyledDiv = styled.div`
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
  }

  .modal-content {
    position: relative;
    background-color: white;
    padding: 20px;
    border-radius: 10px;
    max-height: 90%;
    width: 85%;
    overflow-y: auto;
    overflow-x: auto;
  }

  .close-button {
    position: fixed;
    top: 3%;
    right: 7.5%;
    width: 24px;
    height: 24px;
    background-color: gray;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 1;
  }

  .close-button:hover {
    background-color: darkgray;
  }
`;

const FullModalDiv = ({ isOpen, onClose, children, width }) => {
  return (
    isOpen && (
      <StyledDiv>
        <div className="modal">
          <div
            className="modal-content"
            style={width ? { width } : undefined}
          >
            <button className="close-button" onClick={onClose}>
              X
            </button>
            {React.cloneElement(children, { onClose })}
          </div>
        </div>
      </StyledDiv>
    )
  );
};

export default FullModalDiv;
